var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2400 2400",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 200,
    strokeLinecap: "round",
    stroke: "#aaa",
    fill: "none",
    id: "spinner"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 600,
    x2: 1200,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    x1: 1200,
    y1: 2300,
    x2: 1200,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.917,
    x1: 900,
    y1: 680.4,
    x2: 650,
    y2: 247.4
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.417,
    x1: 1750,
    y1: 2152.6,
    x2: 1500,
    y2: 1719.6
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.833,
    x1: 680.4,
    y1: 900,
    x2: 247.4,
    y2: 650
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.333,
    x1: 2152.6,
    y1: 1750,
    x2: 1719.6,
    y2: 1500
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.75,
    x1: 600,
    y1: 1200,
    x2: 100,
    y2: 1200
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.25,
    x1: 2300,
    y1: 1200,
    x2: 1800,
    y2: 1200
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.667,
    x1: 680.4,
    y1: 1500,
    x2: 247.4,
    y2: 1750
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.167,
    x1: 2152.6,
    y1: 650,
    x2: 1719.6,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.583,
    x1: 900,
    y1: 1719.6,
    x2: 650,
    y2: 2152.6
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.083,
    x1: 1750,
    y1: 247.4,
    x2: 1500,
    y2: 680.4
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    keyTimes: "0;0.08333;0.16667;0.25;0.33333;0.41667;0.5;0.58333;0.66667;0.75;0.83333;0.91667",
    values: "0 1199 1199;30 1199 1199;60 1199 1199;90 1199 1199;120 1199 1199;150 1199 1199;180 1199 1199;210 1199 1199;240 1199 1199;270 1199 1199;300 1199 1199;330 1199 1199",
    dur: "0.83333s",
    begin: "0s",
    repeatCount: "indefinite",
    calcMode: "discrete"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.eba9b2b553ce9830d2632c34d9e24deb.svg";
export { ForwardRef as ReactComponent };